import { defineComponent as _defineComponent } from 'vue'

  import Modal from "@/components/ui/Modal.vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'SuccessInitialHoldModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    lot: {
      type: Object,
      required: true,
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;
  const onClose = () => {
    emits("close");
  };

const __returned__ = { props, emits, onClose, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})